import React from 'react';

const Footer = () => {
  return (
    <div className="text-white text-center my-0 py-0" style={{background:"#0d135b"}}>
      <div className='container'>
        <div className='border-t border-slate-500'> 

        </div>
        <p className='py-5 text-lg font-poppins font-light'> &copy; Copyright 2024-2025. All rights are reserved.</p>
      </div>
    </div>
  );
};

export default Footer;